<template>
  <div class="areas">
    <div class="areas__primary">
      <router-link
        v-for="area in primaryAreas"
        :key="area.id"
        :to="{ name: 'learning-area', params: { id: area.id } }"
        class="areas__card"
        :style="`background-image: url(${getBackground(area.name)})`"
      >
        <div class="areas__card-content">
          <div class="areas__title-wrapper">
            <div class="areas__pass-wrapper">
              <Passes :passName="area.name" />
            </div>
            <h6 class="areas__title">{{ area.name }}</h6>
          </div>
          <div class="areas__arrow-wrapper">
            <img
              src="@/assets/icons/areas/cta_arrow.png"
              alt="Right arrow icon"
            />
          </div>
        </div>
      </router-link>
    </div>
    <div class="areas__secondary">
      <router-link
        v-for="area in secondaryAreas"
        :key="area.id"
        class="areas__tile"
        :style="`background-image: url(${getBackground(area.name)})`"
        :to="{ name: 'learning-area', params: { id: area.id } }"
      >
        <div class="areas__tile-content">
          <div class="areas__tile-title-wrapper">
            <div class="areas__pass-wrapper">
              <Passes :passName="area.name" />
            </div>
            <h6 class="areas__title">{{ area.name }}</h6>
            <div class="areas__tile-arrow-wrapper">
              <img
                src="@/assets/icons/areas/cta_arrow.png"
                alt="Right arrow icon"
              />
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Passes from '@/components/properties/Passes.vue'

export default {
  name: 'Areas',
  components: {
    Passes,
  },
  data() {
    return {
      imageMap: {
        Networking: require('@/assets/images/areas/BG-Networking.jpg'),
        Cloud: require('@/assets/images/areas/BG-Cloud.jpg'),
        'Data Science': require('@/assets/images/areas/BG-DataScience.jpg'),
        Development: require('@/assets/images/areas/BG-Development.jpg'),
        'IT Essentials': require('@/assets/images/areas/BG-ITEssentials.jpg'),
        'Cyber Security': require('@/assets/images/areas/BG-Cybersecurity.jpg'),
      },
    }
  },
  computed: {
    ...mapGetters({
      primaryAreas: 'learningAreas/primaryAreas',
      secondaryAreas: 'learningAreas/secondaryAreas',
    }),
  },
  methods: {
    getBackground(name) {
      const backup = require('@/assets/images/areas/BG-ITEssentials.jpg')
      return this.imageMap[name] || backup
    },
  },
}
</script>

<style lang="scss" scoped>
.areas {
  $this: &;
  margin: 0 0 100px 0;
  padding: 0;
  @include desktop {
    padding: 0 100px;
  }
  &__primary {
    display: grid;
    grid-gap: 5px;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    @include tablet {
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-rows: 1fr;
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }
  &__card {
    height: 150px;
    width: 100%;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    @include tablet {
      height: 250px;
    }
    &:hover {
      opacity: 0.8;
      #{$this}__arrow-wrapper {
        background: var(--dark-gray);
      }
      @include tablet {
        transform: scale(1.03);
      }
    }
  }
  &__title-wrapper {
    display: flex;
    align-items: center;
  }
  &__title {
    font-family: var(--font-bold);
    font-size: 24px;
    color: var(--white);
  }
  &__logo {
    display: none;
    fill: var(--bright-gray);
    height: 50px;
    @include tablet {
      display: block;
      margin: -15px 0 0 125px;
    }
  }
  &__pass-wrapper {
    margin: 0 25px -10px 50px;
  }
  &__arrow-wrapper {
    position: absolute;
    right: 50px;
    bottom: 25px;
    padding: 10px;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    height: 50px;
    width: 50px;
    display: none;
    @include tablet {
      display: flex;
    }
  }
  &__link-icon-wrapper {
    position: absolute;
    right: 50px;
    bottom: 25px;
    padding: 10px;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    height: 50px;
    width: 75px;
    display: none;
    @include tablet {
      display: flex;
    }
  }
  &__get-access {
    position: absolute;
    right: 20px;
    bottom: 55px;
    display: flex;
    align-items: stretch;
    max-width: 100px;
    cursor: pointer;
    &:hover {
      opacity: 1;
      #{$this}__get-access--text {
        color: var(--orange);
      }
    }
    @include tablet {
      left: 20px;
      bottom: 20px;
    }
    &--icon {
      margin: 0 10px 0 0;
      fill: var(--blue);
    }
    &--text {
      margin: 5px 0 0 0;
      padding: 0 0 10px 0;
      text-decoration: underline;
      color: var(--white);
    }
  }
  &__secondary {
    margin: 5px 0 0 0;
    display: grid;
    grid-gap: 5px;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
  }
  &__tile {
    width: 100%;
    height: 150px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
      #{$this}__tile-arrow-wrapper {
        background: var(--dark-gray);
      }
      @include tablet {
        transform: scale(1.03);
      }
    }
  }
  &__tile-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  &__tile-arrow-wrapper {
    position: absolute;
    right: 50px;
    padding: 10px;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    height: 50px;
    width: 50px;
    display: none;
    @include tablet {
      display: flex;
    }
  }
  &__link-name {
    position: absolute;
    right: 25px;
    bottom: 10px;
    color: var(--white);
    font-family: var(--font-bold);
  }
  &__tile-get-access {
    position: absolute;
    right: 20px;
    bottom: 55px;
    display: flex;
    align-items: stretch;
    max-width: 100px;
    &:hover {
      opacity: 1;
      #{$this}__tile-get-access--text {
        color: var(--orange);
      }
    }
    @include tablet {
      left: 7%;
      bottom: 0;
    }
    &--icon {
      margin: 0 10px 0 0;
      fill: var(--purple);
    }
    &--text {
      margin: 5px 0 0 0;
      padding: 0 0 10px 0;
      text-decoration: underline;
      color: var(--white);
    }
  }
}
</style>
